import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 灯组列表接口
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	lightGroupList( params={} ) {
		return request({
	    url: baseUrl + '/device/lampGroup',
	    method: 'GET',
	    params
	  })
	},
	/**
	 * 灯组添加接口
	**/
    lightGroupAdd(data) {
		return request({
	    url: baseUrl + '/device/lampGroup',
	    method: 'POST',
	    data
	  })
	},
	/**
	 * 灯组编辑接口
	**/
	lightGroupEdit(id,data){
		return request({
			url: baseUrl + '/device/lampGroup/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 删除灯组接口
	**/
	lightGroupDel(id){
		return request({
			url: baseUrl + '/device/lampGroup/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 路灯分配-分配或者取消路灯
	 * @param {type} 0未分配1已分配
	 * @param {lamp_ids} 1,2,3 所选设备
	 * @param {group} 路灯ID
	**/
	groupFen(data){
		return request({
			url: baseUrl + '/device/GroupFen',
			method:'POST',
			data
		})
	},

	/**
	 * 路灯分组单控
	 * @param {id} 1,2,3 灯组ID
	 * @param {light} 亮度
	**/
	groupControl(id,data){
		return request({
			url: baseUrl + '/device/lampGroupControl/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 查看该灯组的日志接口
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	virtualMulticastLogList( id,params={} ) {
		return request({
	    url: baseUrl + '/device/virtualMulticastLog/'+id,
	    method: 'GET',
	    params
	  })
	}
}